import React, { useState, useEffect, useContext } from "react";
import Button from "@mui/material/Button";
import { NotificationManager } from "react-notifications";
import { useLocation, useNavigate } from "react-router-dom";

import AddUserModel from "./AddUserModel";
import EditUserModel from "./EditUserModel";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { getAgencyType } from "../../apis/agency/agencyApi";
import getActiveRoles from "../../apis/users/getActiveRoles";
import seachUser from "../../apis/searchUser";
import { UserTypeContext } from "../../AppRoute";
import "./userList.css";
import FormControl from '@mui/material/FormControl';
import OutlinedInput from '@mui/material/OutlinedInput';
import TextField from '@mui/material/TextField';
import Autocomplete from "@mui/material/Autocomplete";
import Excel from "../../components/Icons/excel";
import DataTable from "../../components/DataTable/DataTable";
import Tooltip from "@mui/material/Tooltip";
import UnauthorizedAccess from "../../components/UnauthorizedAccess/UnauthorizedAccess";

const isActiveOption = ["True", "False"];

const UserList = () => {
  const location = useLocation();
  const { userType, userIdType, userRecords } = useContext(UserTypeContext);
  const userRecruitmentpartnerId =
    userType === 'Admin'
      ? location?.state?.userRecruitmentpartnerId
      : userRecords?.recruitmentpartnerId;
  const history = useNavigate();

  // Data & paging state
  const [dataResult, setDataResult] = useState([]);
  const [pageNumber, setPageNumber] = useState(1);
  const [takeNumberOfResult, setTakeNumberOfResult] = useState(10);
  const [totalResult, setTotalResult] = useState(0);
  const [isSearching, setIsSearching] = useState(false);
  const [isExporting, setIsExporting] = useState(false);

  // Roles & agencies
  const [allRoles, setallRoles] = useState([]);
  const [userRoleswithOutCandidate, setUserRoleWithoutCandidate] = useState([]);
  const [agencies, setAgencies] = useState([]);
  const [roleWithoutCustomerAndAdmin, setRoleWithoutCustomerAndAdmin] = useState([]);

  // Filters
  const [filterValue, setFilterValue] = useState({
    firstName: "",
    lastName: "",
    email: "",
    userRole: {},
    isActive: "True"
  });
  const [appliedFilter, setAppliedFilter] = useState({});

  // Modal state
  const [openAddModel, setOpenAddModel] = useState(false);
  const [openEditModel, setOpenEditModel] = useState(false);
  const [editUserData, setEditUserData] = useState({});
  const [isRefreshNeeded, setIsRefreshNeeded] = useState(false);
  const activityOptions = [
    { label: 'All', value: '' },
    { label: 'True', value: 'true' },
    { label: 'False', value: 'false' }
  ]

  function isActiveFilterFn(row, columnId, filterValue) {
    if (!filterValue) return true; // no filter
    const rowValue = row.getValue(columnId);
    const filterValLower = filterValue.toLowerCase();
    if (filterValLower === 'true') return rowValue === true;
    if (filterValLower === 'false') return rowValue === false;
    return true;
  }

  const getIsActiveFilterValue = (column) => {
    const filterValue = column.getFilterValue();
    let value = activityOptions.find(opt => opt.value === filterValue);
    if (!value) {
      value = { label: 'All', value: '' };
    }
    return value;
  }

  // Columns (sample, adjust for your needs)
  const columns = [
    {
      id: "action",
      header: "Action",
      cell: ({ row }) => (
        <Button
          variant="contained"
          color="primary"
          onClick={() => openEditmodal(null, row.original.id, row.original)}
          sx={{
            borderRadius: "8px",
            textTransform: "none",
            fontWeight: "500",
            fontSize: "13px",
            padding: "6px 16px",
            boxShadow: "0 2px 4px rgba(25, 118, 210, 0.2)",
            '&:hover': {
              boxShadow: "0 4px 8px rgba(25, 118, 210, 0.3)",
              transform: "translateY(-1px)"
            },
            transition: "all 0.2s ease",
            // Responsive styling
            '@media (max-width: 768px)': {
              padding: "4px 8px",
              fontSize: "12px",
              minWidth: "60px"
            }
          }}
        >
          Edit
        </Button>
      ),
      size: 120,
      enableSorting: false,
    },
    {
      accessorKey: "firstName",
      header: "First Name",
      size: 200,
    },
    {
      accessorKey: "lastName",
      header: "Last Name",
      size: 200,
    },
    {
      accessorKey: "email",
      header: "Email",
      size: 300,
    },
    {
      accessorKey: "phoneNumber",
      header: "Phone Number",
      size: 180,
    },
    {
      accessorKey: "role.code",
      header: "Primary Role",
      size: 150,
    },
    {
      accessorKey: "role.accessRoles",
      header: "Access Roles",
      size: 400,
    },

    {
      accessorKey: "isActive",
      header: "Is Active",
      size: 150,
      enableSorting: true,
      enableColumnFilter: true,
      filterFn: isActiveFilterFn,
      cell: ({ getValue }) => (getValue() ? "True" : "False"),
      Filter: ({ column }) => (
        <Autocomplete
          disableClearable
          className='isActiveFilter-autocomplete'
          options={activityOptions}
          value={getIsActiveFilterValue(column)}
          onChange={(event, newValue) => {
            column.setFilterValue(newValue ? newValue.value : '');
          }}
          getOptionLabel={(option) => option.label}
          renderInput={(params) => (
            <TextField
              {...params}
              size="small"
            />
          )}
          sx={{ width: '100%' }}
        />
      )
    },
  ];

  // Fetch roles & agency types
  useEffect(() => {
    const getAllRoles = async () => {
      try {
        const allRoleResponse = await getActiveRoles();
        let roleArray = allRoleResponse.data.data;
        roleArray = roleArray.filter((item) => item.roleName !== "Candidate");
        setallRoles(roleArray);
        setUserRoleWithoutCandidate(roleArray);
        if (userType !== "Admin") {
          const filteredRoles = [];
          for (let i = 0; i < roleArray.length; i++) {
            const item = roleArray[i];
            const roleName = item?.roleName;
            if (roleName !== "Customer" && roleName !== "Admin") {
              filteredRoles.push(item);
            }
          }
          roleArray = filteredRoles;
        }
        setRoleWithoutCustomerAndAdmin(roleArray);
      } catch (error) {
        console.log(error);
      }
    };

    const geAllAgencyType = async () => {
      try {
        const allAgency = await getAgencyType();
        setAgencies(allAgency.data.data);
      } catch (error) {
        console.log(error);
      }
    };

    const fetchAllData = async () => {
      try {
        await getAllRoles();
        await geAllAgencyType();
      } catch (error) {
        console.log("Error fetching data:", error);
      }
    };
    fetchAllData();
  }, [userType]);

  // Fetch users on page/filter change
  const fetchUsers = async (
    page = pageNumber,
    pageSize = takeNumberOfResult,
    filters = appliedFilter
  ) => {
    setIsSearching(true);
    let payload = {
      size: pageSize,
      page: page,
      filters: {
        firstName: filters.firstName || "",
        lastName: filters.lastName || "",
        email: filters.email || "",
        userRole: filters.userRole?.id || "",
        isActive: filters.isActive || "True",
      },
    };
    if (userType !== "Admin") {
      payload.userType = userType;
      payload.userRecruitmentpartnerId = userRecruitmentpartnerId;
    }
    try {
      let response = await seachUser(payload);
      setDataResult(response?.data || []);
      setTotalResult(response?.count || 0);
    } catch (error) {
      setDataResult([]);
      setTotalResult(0);
      console.error(error, "error fetching users");
    } finally {
      setIsSearching(false);
    }
  };

  useEffect(() => {
    fetchUsers(pageNumber, takeNumberOfResult, appliedFilter);
    // eslint-disable-next-line
  }, [pageNumber, takeNumberOfResult, appliedFilter, userType, userRecruitmentpartnerId]);

  // Pagination
  const handlePageChange = (newPage, newPageSize) => {
    setPageNumber(newPage);
    if (newPageSize && newPageSize !== takeNumberOfResult) {
      setTakeNumberOfResult(newPageSize);
      setPageNumber(1);
    }
  };

  const handlePageSizeChange = (newPageSize) => {
    setTakeNumberOfResult(newPageSize);
    setPageNumber(1);
  };

  // Filter input handler
  const filterHandler = (event, field, value) => {
    let value1 = typeof value !== 'undefined' ? value : event?.target?.value;
    setFilterValue(prev => ({ ...prev, [field]: value1 }));
  };

  // Search with filters
  const filterSearch = () => {
    if (filterValue.isActive === "") {
      return NotificationManager.error("Active field cannot be empty", "Error", 10000);
    }
    setAppliedFilter(filterValue);
    setPageNumber(1);
  };

  // Edit modal
  const openEditmodal = (event, userId, dataItem) => {
    let selectedUserData = {
      id: dataItem?.id,
      firstName: dataItem?.firstName,
      middleName: dataItem?.MiddleInitial || "",
      lastName: dataItem?.lastName,
      email: dataItem?.email,
      phoneNumber: dataItem?.phoneNumber,
      country: dataItem?.profile?.locationCountry ? JSON.parse(dataItem?.profile?.locationCountry) : "",
      countryCallingCode: dataItem?.countryCode,
      role: dataItem?.role,
      recruitmentPartner: dataItem?.recruitmentpartner,
      agencyType: "",
      agency: "",
      otherRoles: dataItem?.role?.accessRoles,
      status: dataItem?.isActive ? "True" : "False"
    };
    if (dataItem?.role.roleName !== "Candidate") {
      if (dataItem?.agency) {
        let agencyType_edit = agencies.filter((item) => item.id === dataItem.agency.agencyTypeId);
        selectedUserData.agencyType = agencyType_edit[0];
        selectedUserData.agency = dataItem.agency;
      }
    }
    setEditUserData(selectedUserData);
    setOpenEditModel(true);
  };

  // Export to Excel
  const exportToExcel = async () => {
    if (totalResult === 0) {
      NotificationManager.error("No data available to export", "Error", 10000);
      return;
    }
    setIsExporting(true);
    try {
      const maxSize = 100;
      const totalPages = Math.ceil(totalResult / maxSize);
      let currentPage = 1;
      const exportArr = [];
      for (let i = 0; i < totalPages; i++) {
        const payload = {
          size: maxSize,
          page: currentPage,
          filters: {
            firstName: appliedFilter?.firstName,
            lastName: appliedFilter?.lastName,
            email: appliedFilter?.email,
            userRole: appliedFilter?.userRole?.id || "",
            isActive: appliedFilter?.isActive || ""
          }
        };
        if (userType !== "Admin") {
          payload.userType = userType;
          payload.userRecruitmentpartnerId = userRecruitmentpartnerId;
        }
        const response = await seachUser(payload);
        const exportData = response.data;
        exportData.forEach((item) => {
          const data = {
            "First Name": item.firstName,
            "Last Name": item.lastName,
            "Email": item.email,
            "Phone Number": item.phoneNumber,
            "Primary Role": item.role?.roleName || "",
            "Access Roles": item.role?.accessRoles ? item.role.accessRoles.join(", ") : "",
            "Is Active": item.isActive ? "True" : "False"
          };
          exportArr.push(data);
        });
        currentPage++;
      }
      if (exportArr.length === 0) {
        NotificationManager.error("No data present", "Error", 10000);
        setIsExporting(false);
        return;
      }
      // Split into multiple sheets if needed
      const MAX_ROWS_PER_SHEET = 500;
      // Lazy load XLSX only when needed for export
      const { utils, writeFile } = await import("xlsx");
      const wb = utils.book_new();
      const sheetCount = Math.ceil(exportArr.length / MAX_ROWS_PER_SHEET);
      for (let sheetIndex = 0; sheetIndex < sheetCount; sheetIndex++) {
        const startRow = sheetIndex * MAX_ROWS_PER_SHEET;
        const endRow = Math.min((sheetIndex + 1) * MAX_ROWS_PER_SHEET, exportArr.length);
        const subsetData = exportArr.slice(startRow, endRow);
        const ws = utils.json_to_sheet(subsetData);
        utils.book_append_sheet(wb, ws, `Sheet${sheetIndex + 1}`);
      }
      writeFile(wb, "Users.xlsx", { bookType: "xlsx", type: "file" });
    } catch (error) {
      console.error("Error exporting data to Excel", error);
      NotificationManager.error("Error exporting data", "Error", 10000);
    } finally {
      setIsExporting(false);
    }
  };

  // Go to dashboard
  const goToDashboard = () => {
    if (userType === "Admin") {
      history("/admin-home");
    } else {
      history("/dashboard");
    }
  };

  return (
    <>
      {(userType === "Admin" || userType === "Organization Admin" || userType === "MIS Operator") ? (
        <div className="userlist_mainContainer">
          <div className="manageUser_header_container">
            <div className="manageUser_header_left">
              <div className="manageUser_goBackButton" onClick={(e) => goToDashboard(e)}>
                <Tooltip title="Go Back to Dashboard" placement="bottom">
                  <ArrowBackIcon sx={{ fontSize: 20 }} />
                </Tooltip>
              </div>
              <div className="manageUser_title">Manage Users</div>
            </div>
            {userType === "Admin" ?
              <div >
                <Button
                  variant="contained"
                  color="primary"
                  onClick={(e) => setOpenAddModel(true)}
                >
                  Create User
                </Button>
              </div> :
              <div>
                <button onClick={exportToExcel} className="exportExcelBtn">
                  <Excel size={20} className='excelImg_requisitionReports' alt="excelImg" />
                  <span>{isExporting ? 'Exporting...' : 'Export'}</span>
                </button>
              </div>
            }
          </div>

          <div className="userlist_content_maincontainer">

            <div className="filterContainer_manageUser">
              <div className="top-search-bar_manageUser">
                <div className="top-search-text_manageUser">
                  <div className="query-label_manageUser">
                    <span className="query-value_manageUser">Showing Results : Users</span>
                  </div>
                </div>
                <button
                  variant="contained"
                  color="primary"
                  className="search-btn"
                  onClick={filterSearch}
                >
                  Search
                </button>
              </div>
              <div className="manageuser-search-wrapper">
                <div className="filter-box_manageUser">
                  <label className="filter-label_manageUser">First Name</label>
                  <FormControl fullWidth variant="outlined">
                    <OutlinedInput
                      placeholder="Enter First Name"
                      className="outline_textbox_manageuser"
                      value={filterValue.firstName || ""}
                      onChange={(e) => filterHandler(e, "firstName")}
                    />
                  </FormControl>
                </div>
                <div className="filter-box_manageUser">
                  <label className="filter-label_manageUser">Last Name</label>
                  <FormControl fullWidth variant="outlined">
                    <OutlinedInput
                      placeholder="Enter Last Name"
                      className="outline_textbox_manageuser"
                      value={filterValue.lastName || ""}
                      onChange={(e) => filterHandler(e, "lastName")}
                    />
                  </FormControl>
                </div>
                <div className="filter-box_manageUser">
                  <label className="filter-label_manageUser">Email</label>
                  <FormControl fullWidth variant="outlined">
                    <OutlinedInput
                      placeholder="Enter Email"
                      className="outline_textbox_manageuser"
                      value={filterValue.email || ""}
                      onChange={(e) => filterHandler(e, "email")}
                    />
                  </FormControl>
                </div>
                <div className="filter-box_manageUser">
                  <label className="filter-label_manageUser">Primary Role</label>
                  <Autocomplete
                    options={userType === "Admin" ? allRoles : roleWithoutCustomerAndAdmin}
                    getOptionLabel={(option) => option.roleName || ""}
                    value={filterValue.userRole}
                    onChange={(e, value) => filterHandler(e, "userRole", value)}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        placeholder="Select Primary Role"
                      />
                    )}
                  />
                </div>
                <div className="filter-box_manageUser">
                  <label className="filter-label_manageUser">Active</label>
                  <Autocomplete
                    options={isActiveOption}
                    value={filterValue.isActive}
                    closeIcon
                    onChange={(e, value) => filterHandler(e, "isActive", value)}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        placeholder="Select Is Active"
                      />
                    )}
                  />
                </div>
              </div>
            </div>
            <div className="rightSideMainContainer_user">
              <DataTable
                data={dataResult}
                columns={columns}
                isLoading={isSearching}
                totalRecords={totalResult}
                currentPage={pageNumber}
                pageSize={takeNumberOfResult}
                onPageChange={handlePageChange}
                onPageSizeChange={handlePageSizeChange}
                enableFiltering={false}
                enablePagination={true}
                enableSorting={false}
                pageSizeOptions={[10, 20, 50, 100]}
                isServerSide={true}
                noDataText="No results found !"
              />
            </div>
          </div>
        </div>
      ) : (
        <UnauthorizedAccess />
      )}
      {/* Modals */}
      <AddUserModel
        openAddModel={openAddModel}
        setOpenAddModel={setOpenAddModel}
        isRefreshNeeded={isRefreshNeeded}
        setIsRefreshNeeded={setIsRefreshNeeded}
        userRoleswithOutCandidate={userRoleswithOutCandidate}
        agencies={agencies}
        userIdType={userIdType}
        isActiveOption={isActiveOption}
      />
      <EditUserModel
        openEditModel={openEditModel}
        isRefreshNeeded={isRefreshNeeded}
        setOpenEditModel={setOpenEditModel}
        userRoles={editUserData?.role?.roleName !== "Candidate" ? userRoleswithOutCandidate : allRoles}
        agencies={agencies}
        userIdType={userIdType}
        editUserData={editUserData}
        isActiveOption={isActiveOption}
        setIsRefreshNeeded={setIsRefreshNeeded}
        userType={userType}
        userRecruitmentpartnerId={userRecruitmentpartnerId}
        searchValue={dataResult}
        setSearchValue={setDataResult}
        roleWithoutCustomerAndAdmin={roleWithoutCustomerAndAdmin}
      />
    </>
  );
};

export default UserList;
